export default __webpack_public_path__ + "static/media/Lamayuru1.245e3e0f.jpg";